var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F7057",
    strokeWidth: 2,
    fill: "#FFF",
    transform: "translate(16.500000, 16.500000) rotate(-180.000000) translate(-16.500000, -16.500000) ",
    cx: 16.5,
    cy: 16.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F7057",
    strokeWidth: 2,
    transform: "translate(17.244576, 16.853553) rotate(-585.000000) translate(-17.244576, -16.853553) ",
    d: "M7.24457571 16.8535534L27.2445757 16.8535534"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F7057",
    strokeWidth: 2,
    transform: "translate(17.292893, 16.853553) rotate(-585.000000) translate(-17.292893, -16.853553) ",
    d: "M17.2928932 6.85355339L17.2928932 26.8535534"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default __webpack_public_path__ + "static/media/close-round.58f3407c905bac47cf6b687faabba0b2.svg";
export { ForwardRef as ReactComponent };